import React from 'react'
import { useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import services from '../../ioc/services';
import { useState } from 'react';


function ResponseChart() {

    const [stat, setStat] = useState(null);

    const getMonthlyCounts = (data) => {
        const counts = {};

        data.forEach(item => {
            const month = new Date(item.createdAt).toLocaleString('default', { month: 'short' });
            counts[month] = (counts[month] || 0) + 1;
        });

        const result = Object.entries(counts).map(([month, count]) => ({
            name: month,
            hj: count,
            pv: count,
            amt: count
        }));

        return result;
    }


    useEffect(() => {

        services.api.form.getAllFormResponses().then(res => {
            setStat(getMonthlyCounts(res));
        })

    }, [])


    return (
        <>
            {stat &&
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        width={500}
                        height={500}
                        data={stat}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid stroke='none' />
                        <XAxis dataKey="name" fontSize={10} />
                        <YAxis fontSize={10} />
                        <Tooltip />
                        {/* <Legend /> */}
                        {/* <Bar dataKey="pv" fill="#8884d8" /> */}
                        <Bar width={10} dataKey="hj" fill="#82ca9d" />
                    </BarChart>
                </ResponsiveContainer>
            }

        </>
    )
}

export default ResponseChart